import * as React from "react";
import { cn } from "../utils";

export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Optional shape helper */
  variant?: "rect" | "circle";
}

export const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(
  ({ className, style, variant = "rect", ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "animate-pulse bg-neutral-200/80",
        variant === "circle" ? "rounded-full" : "rounded-md",
        className
      )}
      style={style}
      {...props}
    />
  )
);
Skeleton.displayName = "Skeleton";

export function SkeletonText({ lines = 3, className }: { lines?: number; className?: string }) {
  return (
    <div className={cn("space-y-2", className)}>
      {Array.from({ length: lines }).map((_, idx) => (
        <Skeleton key={idx} className={cn("h-3 w-full", idx === lines - 1 && "w-4/5")} />
      ))}
    </div>
  );
}

export function SkeletonAvatar({ size = 48, className }: { size?: number; className?: string }) {
  return <Skeleton variant="circle" className={cn("shrink-0", className)} style={{ width: size, height: size }} />;
}
